(() => {
  'use strict';
  if (window.FleuryFooter) { window.FleuryFooter.refresh(); return; }
  const controllers = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hover = window.matchMedia('(hover: hover)');
  function mount(footer) {
    if (controllers.has(footer)) return;
    const line = footer.querySelector('.fa-footer__colorline');
    const reveal = footer.querySelector('.fa-footer__colorreveal');
    if (!line || !reveal) return;
    const events = new AbortController();
    let visible = false;
    let running = false;
    let timer;
    const finish = () => { clearTimeout(timer); running = false; footer.removeAttribute('data-footer-playing'); };
    const play = () => {
      if (!visible || running || reduced.matches) return;
      // Read the same computed duration as the current menu, rather than letting the two drift.
      const menu = document.querySelector('.fm-menu[data-fm-slot="header-desktop"], .fm-menu[data-fm-slot="header-mobile"]');
      const value = menu && getComputedStyle(menu).getPropertyValue('--fm-fill-duration').trim();
      const valid = /^(?:\d+\.?\d*|\.\d+)(?:ms|s)$/.test(value || '');
      const duration = valid ? Number.parseFloat(value) * (value.endsWith('ms') ? 1 : 1000) : 560;
      footer.style.setProperty('--fa-footer-fill-duration', `${duration}ms`);
      running = true;
      footer.setAttribute('data-footer-playing', '');
      timer = window.setTimeout(finish, duration + 100);
    };
    const visibility = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        const next = entry.isIntersecting && entry.intersectionRatio >= .5;
        const entering = next && !visible;
        visible = next;
        if (entering) play();
      }
    }, { threshold: [0, .5] }) : null;
    visibility?.observe(line);
    if (!visibility) visible = true;
    footer.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch' && hover.matches) play(); }, { signal: events.signal });
    footer.addEventListener('focusin', event => { if (!footer.contains(event.relatedTarget)) play(); }, { signal: events.signal });
    reveal.addEventListener('animationend', event => { if (event.animationName === 'fa-footer-fill') finish(); }, { signal: events.signal });
    const motionChange = () => { if (reduced.matches) finish(); };
    reduced.addEventListener('change', motionChange);
    // Contact remains a neutral service entry in this footer, including app-published menus.
    const contactLabel = () => {
      for (const link of footer.querySelectorAll('.fm-menu[data-fm-slot="footer-service"] a.fm-link[href]')) {
        const label = link.querySelector('.fm-label-text');
        const url = new URL(link.getAttribute('href'), location.href);
        const contact = link.closest('[data-fm-item="kontakt"]') || /\/pages\/(?:contact|contatti)\/?$/.test(url.pathname);
        if (url.origin === location.origin && contact && label && label.textContent !== footer.dataset.footerContactLabel) label.textContent = footer.dataset.footerContactLabel;
      }
    };
    const menuObserver = new MutationObserver(contactLabel);
    menuObserver.observe(footer, { childList: true, subtree: true });
    contactLabel();
    controllers.set(footer, () => {
      finish(); events.abort(); visibility?.disconnect(); menuObserver.disconnect();
      reduced.removeEventListener('change', motionChange); controllers.delete(footer);
    });
  }
  function refresh() {
    controllers.forEach((destroy, footer) => { if (!footer.isConnected) destroy(); });
    document.querySelectorAll('[data-fa-footer-refresh]').forEach(mount);
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => controllers.forEach((destroy, footer) => { if (event.target.contains(footer)) destroy(); }));
  window.addEventListener('pagehide', () => controllers.forEach(destroy => destroy()));
  window.addEventListener('pageshow', refresh);
  window.FleuryFooter = Object.freeze({ refresh });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
})();
